import { Component, computed, inject, Type } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AppLayoutService } from '../../app-layout.service';
import { UserService } from '../../../../../shared/services/user.service';
import { AuthService } from '../../../../../shared/services/auth.service';
import { LocationCompanyService } from '../../../../../shared/services/location-company.service';
import { LocationIndividualService } from '../../../../../shared/services/location-individual.service';
import { DynamicIconComponent } from '../../../../../shared/ui/dynamic-icon/dynamic-icon';
import { BarChartSquare02 } from '../../../../../shared/icons/bar-chart-square-02/bar-chart-square-02';
import { Cube01 } from '../../../../../shared/icons/cube-01/cube-01';
import { Clock } from '../../../../../shared/icons/clock/clock';
import { Calendar } from '../../../../../shared/icons/calendar/calendar';
import { Settings01 } from '../../../../../shared/icons/settings-01/settings-01';

interface MenuItem {
  label: string;
  route: string;
  iconComponent: Type<any>;
}

const COMPANY_NAV: MenuItem[] = [
  { label: 'Kontrolna tabla', route: '/company/dashboard', iconComponent: BarChartSquare02 },
  { label: 'Paketi', route: '/company/packages', iconComponent: Cube01 },
  { label: 'Moji termini', route: '/company/appointments', iconComponent: Clock },
  { label: 'Kalendar', route: '/company/calendar', iconComponent: Calendar },
];

const INDIVIDUAL_NAV: MenuItem[] = [
  { label: 'Moji termini', route: '/individual/appointments', iconComponent: Clock },
  { label: 'Kupovina', route: '/individual/packages/offer', iconComponent: Cube01 },
  { label: 'Kalendar', route: '/individual/calendar', iconComponent: Calendar },
];

@Component({
  standalone: true,
  selector: 'app-client-menu-drawer',
  imports: [RouterLink, RouterLinkActive, DynamicIconComponent, Settings01],
  templateUrl: './client-menu-drawer.html',
  styleUrl: './client-menu-drawer.scss',
})
export class ClientMenuDrawer {
  sidebarService = inject(AppLayoutService);
  userService = inject(UserService);
  private _authService = inject(AuthService);
  private _companyLocation = inject(LocationCompanyService);
  private _individualLocation = inject(LocationIndividualService);
  hoveredRoute: string | null = null;

  menuItems = computed(() =>
    this.userService.isCompany() ? COMPANY_NAV : INDIVIDUAL_NAV
  );

  onMenuItemClick(): void {
    this.sidebarService.isDrawerVisible.set(false);
  }

  goToSettings(): void {
    if (this.userService.isCompany()) {
      this._companyLocation.routeToSettings();
    } else {
      this._individualLocation.routeToSettings();
    }
    this.onMenuItemClick();
  }

  logout(): void {
    this._authService.logout();
    this.onMenuItemClick();
  }
}
